import React from "react";
import PropTypes from "prop-types";

import { Field, Control, Select, Icon } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function ActiveSelect({ Active, onChange }) {
  return (
    <Field>
      <Control iconLeft>
        <Select.Container fullwidth>
          <Select name="Active" value={Active} onChange={onChange}>
            <Select.Option value="true">Active</Select.Option>
            <Select.Option value="false">Inactive</Select.Option>
          </Select>
        </Select.Container>
        <Icon align="left">
          <FontAwesomeIcon icon="edit" />
        </Icon>
      </Control>
    </Field>
  );
}
ActiveSelect.propTypes = {
  Active: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};
export default ActiveSelect;
